import { FormikProps, connect } from 'formik';
import React from 'react';
import isEqual from 'react-fast-compare';
import { SessionStorage } from 'src/utils/SessionStorage';

export interface PersistProps {
  name: string;
}

export class PersistFormImpl extends React.Component<PersistProps & { formik: FormikProps<any> }, {}> {

  componentWillMount() {
    window.addEventListener('beforeunload', this.clearStorage);
  }

  componentDidMount() {
    const formProperties = SessionStorage.tryGetItem(this.props.name);
    if (formProperties && formProperties !== null) {
      const formValue = JSON.parse(formProperties).values;
      this.props.formik.setValues(formValue);
    }
  }

  componentDidUpdate(prevProps: PersistProps & { formik: FormikProps<any> }) {
    if (!isEqual(prevProps.formik, this.props.formik)) {
      SessionStorage.trySetItem(this.props.name, JSON.stringify(this.props.formik));
    }
  }

  clearStorage = () => {
    SessionStorage.tryRemoveItem(this.props.name);
  };

  render() {
    return null;
  }
}

export const Persist = connect<PersistProps, any>(PersistFormImpl);
